import { render, staticRenderFns } from "./ProductDisplayCategoryBatchPopupIframe.vue?vue&type=template&id=130dbb58&"
import script from "./ProductDisplayCategoryBatchPopupIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductDisplayCategoryBatchPopupIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports